import { SubscriptionHookOptions, useSubscription } from "@apollo/client";

import {
  AllGoalTemplatesDocument,
  AllGoalTemplatesSubscription,
  AllGoalTemplatesSubscriptionVariables
} from "@typing/Generated";

type GoalTemplate = NonNullable<NonNullable<AllGoalTemplatesSubscription["allGoalTemplates"]>["goalTemplate"]>;

type UpdateFunc = (goal: GoalTemplate) => void;

const useSubscribeToAllGoalTemplates = (
  onUpdate?: UpdateFunc,
  options?: SubscriptionHookOptions<AllGoalTemplatesSubscription, AllGoalTemplatesSubscriptionVariables>
) => {
  useSubscription<AllGoalTemplatesSubscription, AllGoalTemplatesSubscriptionVariables>(AllGoalTemplatesDocument, {
    ...options,
    onData: data => {
      if (data.data.data?.allGoalTemplates?.goalTemplate && onUpdate) {
        onUpdate(data.data.data.allGoalTemplates.goalTemplate);
      }
    }
  });
};

export default useSubscribeToAllGoalTemplates;
